<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="our-product-contents">
          <div class="our-product-header-component text-center">
            <div v-if="bannerTittle != ''" class="our-product-header">
              <h1 class="our-product-header-content" v-html="bannerTittle"></h1>
            </div>
            <div v-if="bannerDescription != ''" class="row">
              <div class="col-md-12">
                <h3 class="our-product-header-subcontent">{{ bannerDescription }}</h3>
              </div>
            </div>
          </div>

          <div class="our-product-image-component">
            <div class="row">
              <div v-if="ourProductBannerImage != ''" class="col-md-8">
                <a
                  :href="ourProductBannerImageHref"
                  :target="ourProductBannerImageHrefTarget"
                  class="our-product-image"
                >
                  <picture>
                    <img
                      class="lazyload"
                      :alt="ourProductBannerImageAlt"
                      :data-src="ourProductBannerImage"
                    />
                  </picture>
                </a>
              </div>

              <div class="col-md-4">
                <div
                  v-for="(banner, index) in ourProductImageContent"
                  :key="index"
                  class="our-product-image-content text-center"
                >
                  <h2 v-if="banner.buttonTitle != ''" class="our-product-title">
                    {{ banner.buttonTitle }}
                  </h2>
                  <h4 v-if="banner.buttonDescription != ''" class="our-product-description">
                    {{ banner.buttonDescription }}
                  </h4>
                  <div v-if="banner.buttonLink != ''" class="mixa-redesign-footer-common-btn">
                    <a
                      :href="banner.buttonLink"
                      role="button"
                      class="btn-primary mixa-redesign-footer-btn"
                    >
                      <strong>{{ banner.buttonText }}</strong>
                    </a>
                  </div>
                  <span
                    v-scroll-to="{
                      el: '#site-menu',
                      container: 'body',
                      duration: 500,
                      easing: 'ease',
                      offset: 0,
                      force: true,
                      cancelable: true,
                      onStart: function (element) {
                        changeBackground();
                      },
                      onDone: function (element) {
                        changeBackground();
                      },
                      onCancel: function (element) {
                        changeBackground();
                      },
                      x: false,
                      y: true,
                    }"
                    class="our-product-float-btn"
                    :style="{ background: activeColor }"
                  >
                    <svg
                      v-if="!active"
                      class="icon button-plus mixa-redesign-mobile-collapse-plus-btn"
                    >
                      <title>Close collapsible</title>
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="#acco_up_blue"
                      ></use>
                    </svg>
                    <svg
                      v-if="active"
                      class="icon button-plus mixa-redesign-mobile-collapse-plus-btn"
                    >
                      <title>Close collapsible</title>
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="#acco_up_whit"
                      ></use>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mixa-banner-redesign',
  props: {
    bannerTittle: {
      type: String,
      required: false,
    },
    bannerDescription: {
      type: String,
      required: false,
    },
    ourProductImageContent: {
      type: Array,
      required: false,
    },
    ourProductBannerImage: {
      type: String,
      required: false,
    },
    ourProductBannerImageAlt: {
      type: String,
      required: false,
    },
    ourProductBannerImageHref: {
      type: String,
      required: false,
    },
    ourProductBannerImageHrefTarget: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      activeBgColor: '',
      active: false,
    };
  },
  created() {
    // Created functions
  },
  methods: {
    // Functions
    changeBackground() {
      ((this.active = !this.active), (this.activeColor = this.active ? '#0075ba' : ''));
    },
  },
};
</script>
